import { useFormik } from "formik";
import * as Yup from 'yup';
import { TransfersRequest } from "../../../modules/Transfers/types/transfers-response";
import { TransferStatus } from "../../../modules/Transfers/types/transfer-status";

// Esquema de validación
export const transferRequestValidationSchema = Yup.object({
  dependency_id: Yup.string().required('Requerido'),
  //new_dependency_id: Yup.string().required('Requerido'),
  new_responsible_id: Yup.string().required('Requerido'),
  observations: Yup.string(),
});

// Hook customizado
interface UseTransferRequestFormikProps {
  onSubmit: (values: Partial<TransfersRequest>) => void;
}

const useTransferRequestFormik = ({ onSubmit }: UseTransferRequestFormikProps) => {
  return useFormik<Partial<TransfersRequest>>({
    initialValues: {
      dependency_id: '',
      //new_dependency_id: '',
      new_responsible_id: '',
      status_id: TransferStatus.NUEVO,
      observations: '',
    },
    validationSchema: transferRequestValidationSchema,
    onSubmit,
  });
};

export default useTransferRequestFormik;
